import { JSONObject, LayoutObject } from '../../types/types';
import { getMatrixPlacement } from './getMatrixPlacement';

// Creates a rows × columns grid of buttons from the dialog values and fills
// it with the API data (left→right, top→bottom). Cells without data stay
// empty buttons; data beyond the grid is dropped. inheritedStyle carries the
// styling the buttons start with (template of the last selected object, or
// the FE defaults — see getLayoutObjectInheritedStyle).
export const buildMatrixObjects = (
  matrixValues: JSONObject,
  dataObjects: LayoutObject[],
  inheritedStyle: LayoutObject
): LayoutObject[] => {
  const { rows, columns, width, height, gapX, gapY, startX, startY } =
    getMatrixPlacement(matrixValues);

  const objects: LayoutObject[] = [];

  for (let row = 0; row < rows; row += 1) {
    for (let column = 0; column < columns; column += 1) {
      const data = dataObjects[row * columns + column];

      objects.push({
        // Styling is materialized into the data (same as addObject), so the
        // canvas, the panel and the saved layout all agree. The API data wins
        // should it ever carry styling keys.
        ...inheritedStyle,
        ...(data ?? {}),
        x: startX + column * (width + gapX),
        y: startY + row * (height + gapY),
        width,
        height,
      });
    }
  }

  return objects;
};
